import { useEffect, useState } from "react"
import { Filters } from "../interfaces/Filters"
import { SpaceModel } from "../interfaces/Space"
import { filterSpaces } from "../utils";

type Props = {
    filters: Filters,
    spaces: SpaceModel[]
}

export default function useFilters({ filters, spaces }: Props) {

    const [filteredSpaces, setFilteredSpaces] = useState<SpaceModel[]>();

    useEffect(() => {
        setFilteredSpaces(filterSpaces(spaces, filters));

    }, [filters, spaces])

    return { filteredSpaces }
}